class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.renderBcShippingProgress();
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  async renderBcShippingProgress() {
    const block = this.querySelector('#bc-cart-notification-shipping');
    if (!block) return;

    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      if (!cart || cart.item_count === 0) {
        block.hidden = true;
        block.innerHTML = '';
        return;
      }

      const threshold = 5000;
      const remaining = Math.max(threshold - cart.total_price, 0);
      const progress = Math.min((cart.total_price / threshold) * 100, 100);
      const currency = cart.currency || 'EUR';
      const formatMoney = (cents) =>
        new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(cents / 100);

      block.hidden = false;
      block.innerHTML = `
        <p class="bc-cart-notification-shipping__eyebrow">VERSANDVORTEIL</p>
        <p class="bc-cart-notification-shipping__headline">${
          remaining > 0
            ? `Noch ${formatMoney(remaining)} bis zum kostenlosen Versand.`
            : 'Kostenloser Versand erreicht.'
        }</p>
        <div class="bc-cart-notification-shipping__bar" aria-hidden="true">
          <span style="width:${progress}%"></span>
        </div>
        <p class="bc-cart-notification-shipping__note">Deutschland: 4,50 € · ab 50 € frei · ca. 4–7 Werktage</p>
      `;
    } catch (error) {
      console.error('BEASTLYCHIC Versandvorteil konnte nicht geladen werden.', error);
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
